module.exports = __webpack_public_path__ + "media/images/lp/achievement1-pc-84f7fcb918f0a1140a5967f0345d8031.png";